import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const matrackConfig: TSPConfig = {
  key: 'matrack',
  name: 'Matrack',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your Matrack representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default matrackConfig;
